import styled from "styled-components";

export const AmountSuggestionWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    contain: "content",
    padding: `${theme.spacing.xSmall} 0 ${theme.spacing.medium}`,
}));
